import {CANCELLABLE_PAYOUT_INSTRUCTION_STATUSES, PayoutInstructionStatus} from '@sollapay/enums';

import type {badgeVariantsConfig, IconName} from '@sollapay/ui/components';

/** Derived from the Badge's own variant config so it can't drift as variants are added or renamed. */
type BadgeVariant = keyof typeof badgeVariantsConfig.variants.variant;

interface PayoutStatusDisplay {
  variant: BadgeVariant;
  icon: IconName;
}

const STATUS_DISPLAY: Record<PayoutInstructionStatus, PayoutStatusDisplay> = {
  [PayoutInstructionStatus.SENT]: {variant: 'info', icon: 'send'},
  [PayoutInstructionStatus.CLARIFICATION_REQUESTED]: {variant: 'warning', icon: 'help-circle'},
  [PayoutInstructionStatus.REJECTED]: {variant: 'error', icon: 'x-close'},
  [PayoutInstructionStatus.CANCELLED]: {variant: 'neutral', icon: 'credit-card-cancel'},
  [PayoutInstructionStatus.APPROVED]: {variant: 'info', icon: 'user-check'},
  [PayoutInstructionStatus.FUNDS_IN_TRANSIT]: {variant: 'info', icon: 'refresh'},
  [PayoutInstructionStatus.COMPLETED]: {variant: 'success', icon: 'check-circle'},
  [PayoutInstructionStatus.FAILED]: {variant: 'error', icon: 'alert-circle'}
};

export function getPayoutStatusDisplay(status: PayoutInstructionStatus): PayoutStatusDisplay {
  return STATUS_DISPLAY[status];
}

export function canCancelPayout(status: PayoutInstructionStatus): boolean {
  return CANCELLABLE_PAYOUT_INSTRUCTION_STATUSES.includes(status);
}
